// extracted by mini-css-extract-plugin
export var container = "_bk-1";
export var cornerButtonContainer = "_bk-5";
export var disabled = "_bk-2";
export var fileContainer = "_bk-4";
export var hiddenInput = "_bk-3";
export var widthContainer = "_bk-0";